import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ApolloProvider } from "@apollo/react-hooks";
import store from "constants/store";
import graphQLClient from "constants/graphQLClient";
import AppContainer from "containers/App";
import * as serviceWorker from "./serviceWorker";

// RUM is initialized from the snippet in public/index.html so it survives a
// bundle-load outage. This flag lets that snippet's watchdog detect a failed
// mount.
declare global {
  interface Window {
    __APP_BOOTED__?: boolean;
  }
}

const App: React.FC<{}> = () => (
  <Provider store={store}>
    <ApolloProvider client={graphQLClient}>
      <AppContainer />
    </ApolloProvider>
  </Provider>
);

ReactDOM.render(<App />, document.getElementById("root"));
window.__APP_BOOTED__ = true;

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
